import { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { Avatar, Button, Checkbox, Grid2, Grid,MenuItem, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Tooltip, CircularProgress, TextField } from "@mui/material";
import TokenError from "../tokenError";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { useNavigate } from "react-router-dom";
import 'react-quill/dist/quill.snow.css';
import { Label } from "flowbite-react";
import axios from "axios";
import UploadIcon from '../../assets/icons/Upload.svg';
import InfoIcon from '../../assets/icons/Info.svg';
import prevIcon from '../../assets/icons/left-arrow.svg'
import nextIcon from '../../assets/icons/right-arrow.svg';
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

// Lazy load the ReactQuill editor for better performance
import { lazy, Suspense } from 'react';
import React from "react";
const ReactQuill = lazy(() => import('react-quill'));

const Pushes= () => {

    const [tokenExpired, setTokenExpired] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [driverCustomer, setDriverCustomer] = useState(0);
    const [pushTitle, setPushTitle] = useState('');
    const [vehicleType, setVehicleType] = useState(0);
    const [rows, setRows] = useState([]);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [errorMessage, setErrorMessage] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [customMessage, setCustomMessage] = useState('');
    const [selectedUser, setSelectedUser] = useState([]);
    const [selectedUserIds, setSelectedUserIds] = useState([]);
    const [vehicleClient, setVehicleClient] = useState([]);
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [image, setImage] = useState('');
    const [fileInputKey, setFileInputKey] = useState(Date.now());
    const fileInputRef = useRef(null);
    const [isSending, setIsSending] = useState(false);
    const removeDriverPushes = localStorage.getItem('remove_driver_pushes') || 0;
    const pushesInHtml = localStorage.getItem('pushes_in_html');

    const [paginationInfo, setPaginationInfo] = useState({
        total: 0,
        page_count: 1,
    });

    const [page, setPage] = useState(0); // UI page: 0-based
    const [rowsPerPage] = useState(50);
    const [loadingUsers, setLoadingUsers] = useState(false);

    // Guards against out-of-order responses: only the newest request may write state.
    const requestIdRef = useRef(0);

    const totalPages = Math.max(
        1,
        paginationInfo.page_count || Math.ceil(paginationInfo.total / rowsPerPage)
    );

    const country_code = localStorage.getItem('default_country_iso_code' || 'IN');
    const searchTimeoutRef = useRef(null);
    const [sendtoall, setSendtoall] = useState(0);
    const [tripIdFilter, setTripIdFilter] = useState('');
    const [tripDateFilter, setTripDateFilter] = useState(null);
    const show_trip_id_filter_in_bulk_push = localStorage.getItem('show_trip_id_filter_in_bulk_push');

    const navigate = useNavigate();

    const driver_vehicle_attachment_enabled = localStorage.getItem('driver_vehicle_attachment_enabled');
    const is_client_owned_vehicle = localStorage.getItem('is_client_owned_vehicle');

    const handlePhoneChange = (value) => {
        setTripIdFilter('');
        setTripDateFilter(null);
        const previousPhone = customerPhone;
        const newValue = value || ''; // Handle undefined when input is cleared
        setCustomerPhone(newValue);
      
        // Parse phone number to get country code (optional, for logging or other use)
        let countryCode = '';
        try {
          const parsed = parsePhoneNumber(newValue);
          if (parsed) {
            countryCode = parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '';
          }
        } catch (err) {
          console.error('Invalid phone number:', err);
        }
      
        // Clear any existing timeout
        if (searchTimeoutRef.current) {
          clearTimeout(searchTimeoutRef.current);
        }
      
        // If input is being cleared and we had a previous value
        if (newValue.length === 0 && previousPhone.length > 0) {
          setPage(0);
          fetchUSersData(1, rowsPerPage, '', ''); // Reset search
          return;
        }
      
        // Only make API call if the input has 6 or more characters (including country code)
        if (newValue.length >= 6) {
          searchTimeoutRef.current = setTimeout(() => {
            setPage(0);
            fetchUSersData(1, rowsPerPage, '', newValue);
          }, 500);
        }
    };

    const handleTripIdChange = (e) => {
        const value = e.target.value;
        const previousTripId = tripIdFilter;
        setTripIdFilter(value);
        setCustomerPhone('');
    
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
    
        // If cleared and there was a previous value, reset
        if (value.length === 0 && previousTripId.length > 0) {
            if (tripDateFilter) {
                setPage(0);
                fetchUSersData(1, rowsPerPage, '', '', '', ''); // reset both
            }
            return;
        }
    
        // Only fire when both trip id and trip date are present
        if (value && tripDateFilter) {
            searchTimeoutRef.current = setTimeout(() => {
                setPage(0);
                fetchUSersData(1, rowsPerPage, '', '', value, tripDateFilter);
            }, 500);
        }
    };
    
    const handleTripDateChange = (newValue) => {
        const value = newValue ? newValue.format('YYYY-MM-DD') : '';
        const previousTripDate = tripDateFilter;
        setTripDateFilter(value);
        setCustomerPhone('');
    
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
    
        // If cleared and there was a previous value, reset
        if (!value && previousTripDate) {
            if (tripIdFilter) {
                setPage(0);
                fetchUSersData(1, rowsPerPage, '', '', '', ''); // reset both
            }
            return;
        }
    
        // Only fire when both trip id and trip date are present
        if (value && tripIdFilter) {
            searchTimeoutRef.current = setTimeout(() => {
                setPage(0);
                fetchUSersData(1, rowsPerPage, '', '', tripIdFilter, value);
            }, 500);
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        showSnackbar(false);
    };

    const sendPush = async () => {
        if (isSending) return; // Prevent multiple clicks
        
        // Validation
        if (!customMessage.trim() || customMessage.trim() === '<p><br></p>') {
            return;
        }
        
        if (selectedUserIds.length === 0) {
            return;
        }
        
        if (!pushTitle.trim()) {
            return;
        }

        setIsSending(true);
        
        try {
            const token = localStorage.getItem('token');
            
            // Format the user array with required fields
            const userArray = selectedUser.map(user => ({
                id: user.user_id || user.driver_id,
                name: user.user_name || user.driver_name || '',
                phone_number: user.phone_number || '',
                device_type: user.device_type,
                device_token: user.device_token || '',
            }));

            // console.log('tripIdFilter = ', tripIdFilter, 'tripDateFilter = ', tripDateFilter, 'customerPhone = ', customerPhone)
            
            const noFilters =
                !tripIdFilter &&
                !tripDateFilter &&
                !customerPhone;

            const payload = {
                token: token,
                message: customMessage,
                user_array: userArray,
                user_type: driverCustomer,
                title: pushTitle,
                send_to_all: (sendtoall && noFilters) ? 1 : 0,
                city_id: cityFilter,
            };
            
            if (image !== '') {
                payload.banner = image;
            }
            
            const response = await makePostRequestToUrl(operationsUrl + '/panel/send_pushes', payload);
            
            if (response.flag === 200) {
                setMessage(response.message);
                showSnackbar(true);
                setSelectedUser([]);
                setSelectedUserIds([]);
                setCustomMessage('');
                setPushTitle('');
                setImage('');
                setFileInputKey(Date.now());
                setSendtoall(0);
            }
        } catch (error) {
            console.error('Error sending push:', error);
        } finally {
            setIsSending(false);
        }
    }

    const handleChangePage = (event, newPage) => {
        if (newPage < 0 || newPage >= totalPages) {
            return;
        }
        setPage(newPage);
        fetchUSersData(
            newPage + 1,
            rowsPerPage,
            '',
            customerPhone,
            tripIdFilter,
            tripDateFilter
        );
    };

    const fetchUSersData = async (
        apiPage = 1,
        limit = 50,
        userId = '',
        phoneNumber = '',
        tripId = '',
        tripDate = ''
    ) => {
        const reqId = ++requestIdRef.current;

        try {
            setLoadingUsers(true);

            const token = localStorage.getItem('token');

            const url =
                serverUrl +
                (driverCustomer == 1
                    ? '/driver/fetch_all'
                    : '/panel/fetch_customers_to_send_push');

            const timestamp = new Date().getTime();
            const body = {
                token,
                timestamp,
                page: apiPage,
                page_size: limit,
                city_id: cityFilter,
            };
            
            // Add phone number to the request if provided
            if (phoneNumber) {
                body.phone_number = phoneNumber.replace(/\D/g, '');
            }
            if (tripId && tripDate) {
                body.trip_id = tripId;
                body.trip_date = tripDate;
            }
            if (driverCustomer == 1 && vehicleType != 0) {
                body.vehicle_type = vehicleType;
            }
            
            const response = await makeGetRequestToUrl(url, body);

            // A newer request started while this one was in flight — discard.
            if (reqId !== requestIdRef.current) return;

            // Token expired
            if (response?.flag == 102) {
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                return;
            }

            if (response?.flag !== 200) {
                setRows([]);
                setPaginationInfo({ total: 0, page_count: 1 });
                return;
            }

            // Handle a few possible response shapes.
            let data = [];
            if (Array.isArray(response?.data)) {
                data = response.data;
            } else if (Array.isArray(response?.data?.data)) {
                data = response.data.data;
            } else if (Array.isArray(response?.users)) {
                data = response.users;
            } else if (Array.isArray(response?.results)) {
                data = response.results;
            }

            const totalItems = Number(
                response?.pagination?.total ??
                response?.data?.pagination?.total ??
                response?.total ??
                data.length
            );

            const apiPageCount = Number(
                response?.pagination?.page_count ??
                response?.data?.pagination?.page_count ??
                Math.ceil(totalItems / limit)
            );

            const calculatedTotalPages = Math.max(
                1,
                apiPageCount || Math.ceil(totalItems / limit)
            );

            const sortedData = [...data].sort((a, b) => {
                const idA = Number(a?.user_id || a?.driver_id || 0);
                const idB = Number(b?.user_id || b?.driver_id || 0);
                return idB - idA;
            });

            // This is what actually displays the API data.
            // console.log('sorted data = ', sortedData)
            setRows(sortedData);

            setPaginationInfo({
                total: totalItems,
                page_count: calculatedTotalPages,
            });

            // Keep UI page (0-based) in sync with the API page (1-based).
            setPage(Math.max(0, apiPage - 1));

        } catch (error) {
            console.error('Error fetching users:', error);
            if (reqId !== requestIdRef.current) return;
            setRows([]);
            setPaginationInfo({ total: 0, page_count: 1 });
        } finally {
            // Only the newest request clears the loading flag.
            if (reqId === requestIdRef.current) setLoadingUsers(false);
        }
    };

    const fetchVehicleClient = async () => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/vehicle/get_client_vehicles';
            const timestamp = new Date().getTime();
            const body = { token, city_id: cityFilter, timestamp };
            const response = await makeGetRequestToUrl(url, body);
            if (response.flag == 200) {
                const activeVehicles = response.data.filter(vehicle => vehicle.is_active === 1);
                setVehicleClient(activeVehicles);
                setVehicleType(0);
            }
            if (response.flag == 102) {
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    useEffect(() => {
        setSelectedUser([]);
        setSelectedUserIds([]);
        setCustomMessage('');
        setRows([]);
        setPage(0);

        if (driverCustomer == 1) {
            fetchVehicleClient();
            fetchUSersData(1, rowsPerPage);
        }
        if (driverCustomer == 0) {
            fetchUSersData(1, rowsPerPage);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [driverCustomer]);

    useEffect(() => {
        if (driverCustomer == 1 && vehicleType !== '') {
            setPage(0);
            fetchUSersData(1, rowsPerPage);
        }
    }, [ vehicleType]);

    useEffect(() => {
        setPage(0);
        fetchUSersData(1, rowsPerPage, '', customerPhone, tripIdFilter, tripDateFilter);
        // setTripIdFilter('');
        // setTripDateFilter(null);
        // setCustomerPhone('')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cityFilter]);

    useEffect(() => {
        if ((customerPhone || tripIdFilter || tripDateFilter) && sendtoall === 1) {
            setSendtoall(0);
            setSelectedUser([]);
            setSelectedUserIds([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerPhone, tripIdFilter, tripDateFilter]);

    const handleFilterChange = (filterType, value) => {
        if (filterType === 'city') {
            setPage(0);
            setSelectedUser([]);
            setSelectedUserIds([]);
            setSendtoall(0);
            setCityFilter(value);
        }
    };

    const handleFileChange = async (event) => {
        const fileInput = event.target;
        const files = fileInput.files;
    
        if (files.length === 0) {
            console.error("No file selected");
            return;
        }

        const maxSize = 2 * 1024 * 1024; // 2MB
        if (files[0].size > maxSize) {
            setMessage("Image size should be less than 2MB");
            showSnackbar(true);
            fileInput.value = '';
            setFileInputKey(Date.now());
            return;
        }

        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        if (!allowedTypes.includes(files[0].type)) {
            setMessage("Only JPG, JPEG, and PNG files are allowed");
            showSnackbar(true);
            fileInput.value = '';
            setFileInputKey(Date.now());
            return;
        }

        // Check image dimensions
        const checkDimensions = (file) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = function () {
                    resolve({ width: this.width, height: this.height });
                };
                img.src = URL.createObjectURL(file);
            });
        };

        try {
            const { width, height } = await checkDimensions(files[0]);
            
            // Define maximum dimensions (adjust these values as needed)
            const MAX_WIDTH = 510;
            const MAX_HEIGHT = 350;
            const MIN_WIDTH = 300;
            const MIN_HEIGHT = 250;

            // Check dimensions
            if (width > MAX_WIDTH || height > MAX_HEIGHT) {
                setMessage(`Image dimensions (${width}x${height}) are too large. Maximum allowed is ${MAX_WIDTH}x${MAX_HEIGHT}px`);
                showSnackbar(true);
                fileInput.value = '';
                setFileInputKey(Date.now());
                return;
            }

            if (width < MIN_WIDTH || height < MIN_HEIGHT) {
                setMessage(`Image dimensions (${width}x${height}) are too small. Minimum required is ${MIN_WIDTH}x${MIN_HEIGHT}px`);
                showSnackbar(true);
                fileInput.value = '';
                setFileInputKey(Date.now());
                return;
            }

            const formData = new FormData();
            formData.append("image", files[0]);
        
            const url = operationsUrl + '/upload_image';
        
            const response = await axios.post(url, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            setImage(response.data.url);
        } catch (error) {
            console.error("Error processing image:", error);
            setMessage("Error processing the image. Please try again with a different file.");
            showSnackbar(true);
            fileInput.value = '';
            setFileInputKey(Date.now());
        }
    };

    const moveToPushHistory = () => {
        navigate('/push-history');
    };

    // Debounce to keep the Quill editor from lagging.
    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(this, args), delay);
        };
    };

    const handleEditorChange = useCallback(
        debounce((content) => {
            setCustomMessage(content);
        }, 300),
        []
    );

    const editorModules = useMemo(() => ({
        toolbar: [['bold', 'italic', 'underline', 'strike']],
        clipboard: { matchVisual: false }
    }), []);

    // Column count for full-width loading / empty rows.
    const customerColSpan = show_trip_id_filter_in_bulk_push == 1 ? 6 : 4;
    const driverColSpan = 4;

    const hasFilters = !!(tripIdFilter || tripDateFilter || customerPhone);
    const isSendToAll = sendtoall === 1 && !hasFilters;
    const selectedCount = isSendToAll ? paginationInfo.total : selectedUser.length;

    return (
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Pushes
            </Typography>

            <Grid2 item container spacing={2} alignItems="center" sx={{ marginTop: '1%', marginBottom: '2%' }}>
                <Grid2 item>
                    <Select
                        value={cityFilter}
                        onChange={(e) => handleFilterChange('city', e.target.value)}
                        displayEmpty
                        style={{
                            width: '220px',
                            height: '50px',
                            borderRadius: '8px',
                            backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_id} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 sx={{marginLeft:'auto'}}>
                    <Button
                        variant="contained"
                        onClick={moveToPushHistory}
                        style={{
                            width: '185px',
                            height: '50px',
                            backgroundColor: '#0065ff',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        View Push Details
                    </Button>
                </Grid2>
            </Grid2>

            <Grid2 container item spacing={2} sx={{display:'flex', marginTop:'1%'}}>
                <Grid2 item size={4} className="mainBox" style={{overflow:'auto',maxHeight: 'calc(100vh - 210px)'}}>
                    <Typography sx={{color: '#4E545D', fontSize:'24px'}}>Create Push</Typography>

                    <Grid2 sx={{marginTop:'6%'}}>
                        <Typography sx={{color: '#2A313C'}}>Send Push to</Typography>

                        <Select
                            value={driverCustomer}
                            onChange={(e) => {
                                setDriverCustomer( e.target.value)
                                setSendtoall(0);
                            }} 
                            displayEmpty fullWidth
                            style={{ height: '50px', borderRadius: '8px', backgroundColor: driverCustomer ? '#F9F9F9' : '#FFFFFF', border: 'none', marginTop:'1%'}}>
                            {/* <MenuItem value="-1">Select</MenuItem> */}
                            {removeDriverPushes==0 && <MenuItem value="1">Driver</MenuItem>}
                            <MenuItem value="0">Customer</MenuItem>
                        </Select>
                    </Grid2>

                    <Grid2 xs="auto" sx={{marginTop:'4%'}}>
                    <Typography sx={{color: '#2A313C'}}>Notification Title <span style={{ color: 'red' }}>*</span></Typography>

                        <input type="text" placeholder="Notification Title" className='filterBtn' value={pushTitle} onChange={(e) => setPushTitle(e.target.value)}
                        style={{ height: '50px', borderRadius: '8px', backgroundColor: driverCustomer ? '#F9F9F9' : '#FFFFFF',border: '1px solid #E0E0E0', marginTop:'1%',width:'95%'}}
                        />
                    </Grid2>

                    <Grid item xs={12} sm={6} sx={{marginTop:'4%'}}>
                        <Label>Image (Optional)</Label>
                        <input
                            key={fileInputKey}
                            ref={fileInputRef}
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                            id="image-upload"
                        />
                        <label htmlFor="image-upload">
                            <div style={{
                                border: '1px dashed #B0BEC5',
                                borderRadius: '8px',
                                padding: '20px',
                                textAlign: 'center',
                                cursor: 'pointer',
                                marginTop: '8px',
                                backgroundColor: '#F9F9F9',
                                '&:hover': {
                                    backgroundColor: '#F0F0F0',
                                }
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                                    <img 
                                        src={UploadIcon} 
                                        alt="Upload" 
                                        style={{ width: '24px', height: '24px' }}
                                    />
                                    <Typography variant="caption" color="textSecondary">
                                        Choose File
                                    </Typography>
                                </div>
                            </div>
                        </label>
                        <div style={{ display: 'flex', alignItems: 'start', gap: '8px', marginTop: '8px' }}>
                            <img src={InfoIcon} alt="info" style={{ width: '15px', height: '15px', cursor: 'pointer' }} />
                            <Typography sx={{fontSize:'10px'}} color="textSecondary">
                                Size (max 2MB) & Dimension Should be max 510 x 350 Px & min 300 x 250 Px
                            </Typography>
                        </div>

                        {image && (
                            <div style={{ marginTop: '12px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <img 
                                    src={image} 
                                    alt="Preview" 
                                    style={{ 
                                        height: '50px', 
                                        width: '50px',
                                        objectFit: 'cover',
                                        borderRadius: '4px'
                                    }}
                                />
                                <Button 
                                    variant="outlined" 
                                    size="small"
                                    onClick={() => {
                                        setImage('');
                                        if (fileInputRef.current) {
                                            fileInputRef.current.value = '';
                                            setFileInputKey(Date.now());
                                        }
                                    }}
                                >
                                    Remove
                                </Button>
                            </div>
                        )}
                    </Grid>

                    {false && (driverCustomer==1 && (driver_vehicle_attachment_enabled==1 || (driver_vehicle_attachment_enabled==0 && is_client_owned_vehicle==0))) && (
                        <Grid2 sx={{marginTop:'4%'}}>
                            <Typography sx={{color: '#2A313C'}}>Vehicle Type</Typography>

                            <Select
                                value={vehicleType}
                                onChange={(e) => setVehicleType( e.target.value)} displayEmpty fullWidth
                                style={{ height: '50px', borderRadius: '8px', backgroundColor: driverCustomer ? '#F9F9F9' : '#FFFFFF', marginTop:'1%'}}>
                                    <MenuItem value="0">All</MenuItem>
                                    {vehicleClient.map((vehicle) => (
                                        <MenuItem key={vehicle.vehicle_type} value={vehicle.vehicle_type}>
                                            {vehicle.vehicle_name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </Grid2>
                    )}

                    <Grid2 sx={{marginTop:'4%'}}>
                        <Typography sx={{color: '#2A313C'}}>Notification Message <span style={{ color: 'red' }}>*</span></Typography>

                        {pushesInHtml==1 ? <Suspense fallback={<div style={{height: '140px', border: '1px solid #E0E0E0', borderRadius: '8px'}}>Loading editor...</div>}>
                            <div className="quill-editor-container" style={{ marginTop: '1%', borderRadius: '8px', overflow: 'hidden' }}>
                                <ReactQuill
                                    theme="snow"
                                    value={customMessage}
                                    onChange={handleEditorChange}
                                    placeholder="Write your message here."
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                    }}
                                    className="custom-quill"
                                    modules={editorModules}
                                />
                                <style jsx global>{`
                                .custom-quill .ql-container {
                                    border: 1px solid #E0E0E0 !important;
                                    border-radius: 0 0 8px 8px !important;
                                    min-height: 140px;
                                }
                                .custom-quill .ql-toolbar {
                                    border: 1px solid #E0E0E0 !important;
                                    border-bottom: none !important;
                                    border-radius: 8px 8px 0 0 !important;
                                    background-color: #f8f9fa;
                                }
                                .custom-quill .ql-editor {
                                    min-height: 140px;
                                }
                            `}</style> 
                            </div>
                            <div style={{ display: 'flex', alignItems: 'start', gap: '8px', marginTop: '8px' }}>
                                <img src={InfoIcon} alt="info" style={{ width: '15px', height: '15px', cursor: 'pointer' }} />
                                <Typography sx={{fontSize:'10px'}} color="textSecondary">
                                    Placeholder For {driverCustomer == 1 ? 'Driver Name {name}': 'User Name {name}'}
                                    <br />
                                    Placeholder For {driverCustomer == 1 ? 'Driver Phone Number {phone_number}': 'User Phone Number {phone_number}'}
                                </Typography>
                            </div>
                        </Suspense>:<TextField
                            multiline
                            rows={4}
                            value={customMessage}
                            onChange={(e) => setCustomMessage(e.target.value)}
                            style={{
                                width: '100%',
                                height: '125px',
                                borderRadius: '8px',
                                border: '1px solidrgb(255, 254, 254)',
                                marginTop: '1%',
                                backgroundColor: '#F9F9F9',
                            }}
                        />}
                    </Grid2>
                    
                    <Grid2 style={{marginTop:'8%'}}>
                        <Button 
                            type="submit" 
                            variant="contained" 
                            disabled={!customMessage.trim() || 
                                     customMessage.trim() === '<p><br></p>' || 
                                     selectedUserIds.length === 0 || 
                                     !pushTitle.trim() ||
                                     isSending} 
                            fullWidth 
                            style={{ 
                                color:"#fff", 
                                textTransform:'none', 
                                borderRadius:'10px', 
                                backgroundColor: (customMessage.trim() && 
                                               customMessage.trim() !== '<p><br></p>' && 
                                               selectedUserIds.length > 0 && 
                                               pushTitle.trim() &&
                                               !isSending) ? '#0065FF' : '#B0BEC5', 
                                cursor: (customMessage.trim() && 
                                        customMessage.trim() !== '<p><br></p>' && 
                                        selectedUserIds.length > 0 &&
                                        !isSending) ? 'pointer' : 'not-allowed'
                            }} 
                            onClick={sendPush}
                        >
                            {isSending ? (
                                <CircularProgress size={24} style={{ color: '#fff' }} />
                            ) : (
                                'Send Push'
                            )}
                        </Button>
                    </Grid2>
                </Grid2>

                <Grid2 item size={8} className="mainBox">
                    <Grid sx={{display:'flex'}}>
                        <Grid sx={{mt:"12px"}}>

                            <Grid2 sx={{ display: 'flex', alignItems: 'center', marginTop: '12px' }}>
                                <Checkbox
                                    checked={sendtoall === 1}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        setSendtoall(isChecked ? 1 : 0);
                                        if (isChecked) {
                                            setSelectedUser([...rows]);
                                            setSelectedUserIds(rows.map(row => row.user_id || row.driver_id));
                                        } else {
                                            setSelectedUser([]);
                                            setSelectedUserIds([]);
                                        }
                                    }}
                                    inputProps={{ 'aria-label': 'select all users' }}
                                    sx={{ padding: '4px' }}
                                />
                                <Typography sx={{ fontSize: '14px', color: '#2A313C' }}>
                                    Select All
                                    
                                </Typography>
                                
                            </Grid2>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '16px', minHeight: '16px', marginLeft:'8px' }}>
                            {selectedCount > 0 && (
                                <Grid2 sx={{ marginTop: '4px' }}>
                                    <Typography sx={{ fontSize: '12px', color: '#0065ff' }}>
                                        {selectedCount} {selectedCount === 1 ? 'User' : 'Users'} Selected
                                    </Typography>
                                </Grid2>
                            )}
                            </div>
                        </Grid>

                    <Grid2 container spacing={2} sx={{ alignItems: 'flex-start', marginTop: '1%', flexWrap: 'wrap', ml:'auto' }}>
                        {/* Phone filter */}
                        <Grid2>
                            <Typography sx={{ fontSize: '12px', color: '#83888E', marginBottom: '4px' }}>
                                Search by Phone Number
                            </Typography>
                            <style>
                                {`
                                .PhoneInputCountry {
                                    border-radius: 8px 0px 0px 8px !important;
                                    border: none !important;
                                    background-color: ${customerPhone ? '#F9F9F9' : '#FFFFFF'} !important;
                                    padding: 4px !important;
                                    margin-right: 0px !important;
                                    }
                                    .PhoneInputInput {
                                        font-size: 16px !important;
                                        border: none !important;
                                        outline: none !important;
                                        }
                                        .PhoneInputInput::placeholder {
                                        font-size: 16px !important;
                                        }
                                    `}
                            </style>
                            <PhoneInput
                                defaultCountry={country_code || "IN"}
                                placeholder="Enter phone number"
                                value={customerPhone}
                                onChange={handlePhoneChange}
                                style={{
                                    height: '40px',
                                    width: '220px',
                                    backgroundColor: customerPhone ? '#F9F9F9' : '#FFFFFF',
                                    borderRadius: '8px',
                                    border: '1px solid #E0E0E0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '0 12px'
                                }}
                            />
                        </Grid2>

                        {(show_trip_id_filter_in_bulk_push==1) && 
                        <>
                        
                        {/* Divider label between the two filter groups */}
                        <Grid2 sx={{ display: 'flex', alignItems: 'center', height: '40px', marginTop: '18px' }}>
                            <Typography sx={{ fontSize: '12px', color: '#B0BEC5', fontStyle: 'italic' }}>or</Typography>
                        </Grid2>

                        {/* Trip filter group - visually boxed together */}
                        <Grid2>
                            <Typography sx={{ fontSize: '12px', color: '#83888E', marginBottom: '4px' }}>
                                Search by Trip Details (both fields required)
                            </Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div style={{
                                    display: 'flex',
                                    gap: '10px',
                                    alignItems: 'center',
                                    border: '1px solid #E0E0E0',
                                    borderRadius: '8px',
                                    padding: '6px 10px',
                                    backgroundColor: (tripIdFilter || tripDateFilter) ? '#F9F9F9' : '#FFFFFF',
                                }}>
                                    <TextField
                                        placeholder="Trip ID"
                                        value={tripIdFilter}
                                        onChange={handleTripIdChange}
                                        size="small"
                                        variant="standard"
                                        InputProps={{ disableUnderline: true }}
                                        style={{ width: '90px' }}
                                    />
                                    <div style={{ width: '1px', height: '24px', backgroundColor: '#E0E0E0' }} />
                                    <DatePicker
                                        value={tripDateFilter ? dayjs(tripDateFilter) : null}
                                        onChange={handleTripDateChange}
                                        slotProps={{
                                            textField: {
                                                size: 'small',
                                                variant: 'standard',
                                                placeholder: 'Trip Date',
                                                InputProps: { disableUnderline: true },
                                                style: { width: '130px' },
                                            },
                                        }}
                                    />
                                </div>
                            </LocalizationProvider>

                            {/* Status message: neutral by default, red warning when only one field is filled, green confirmation when both are set */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '6px', minHeight: '16px' }}>
                                {(tripIdFilter && !tripDateFilter) || (!tripIdFilter && tripDateFilter) ? (
                                    <>
                                        <img src={InfoIcon} alt="info" style={{ width: '13px', height: '13px' }} />
                                        <Typography sx={{ fontSize: '11px', color: '#D32F2F' }}>
                                            Enter both Trip ID and Trip Date to apply this filter
                                        </Typography>
                                    </>
                                ) : tripIdFilter && tripDateFilter ? (
                                    <Typography sx={{ fontSize: '11px', color: '#2E7D32' }}>
                                        ✓ Filtering by Trip ID and Date
                                    </Typography>
                                ) : (
                                    <Typography sx={{ fontSize: '11px', color: '#B0BEC5' }}>
                                        Both Trip ID and Trip Date needed together
                                    </Typography>
                                )}
                            </div>
                        </Grid2>

                        </>
                        }

                        {/* {sendtoall == 0 && selectedUser.length > 0 && (
                            <Grid2 sx={{ marginTop: '18px' }}>
                                <div style={{ border: '1px solid #E0E0E0', padding: '10px 20px', borderRadius: '8px', whiteSpace: 'nowrap' }}>
                                    {selectedUser.length} User Selected
                                </div>
                            </Grid2>
                        )} */}
                    </Grid2>
                    </Grid>

                    <Typography sx={{ fontSize: '12px', color: '#83888E', mt: '8px' }}>
                        {loadingUsers
                            ? 'Loading…'
                            : `${rows.length} record${rows.length === 1 ? '' : 's'} on this page — ${paginationInfo.total} total`}
                    </Typography>

                    <TableContainer className="table-container" sx={{ mt: '4px', maxHeight: 'calc(100vh - 350px)' }}>
                        <Table stickyHeader className="scrollable-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Select</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>User</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>User ID</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Email</TableCell>
                                    {show_trip_id_filter_in_bulk_push==1 && <TableCell align="center" className="table-header" style={{ width: '15%' }}>Trip ID</TableCell>}
                                    {show_trip_id_filter_in_bulk_push==1 && <TableCell align="center" className="table-header" style={{ width: '15%' }}>Trip Date</TableCell>}
                                </TableRow>
                            </TableHead>

                            {driverCustomer==0 && (
                                <TableBody>
                                    {loadingUsers ? (
                                        <TableRow>
                                            <TableCell colSpan={customerColSpan} align="center" sx={{ py: 3 }}>
                                                <CircularProgress size={24} />
                                            </TableCell>
                                        </TableRow>
                                    ) : rows.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={customerColSpan} align="center" sx={{ py: 3 }}>
                                                <Typography sx={{ color: '#83888E' }}>No data received</Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : rows.map((row) => (
                                        <TableRow key={row.user_id}>
                                            <TableCell align="center" sx={{ minWidth: '60px' }}>
                                                <Checkbox
                                                    checked={isSendToAll || selectedUser.some(selected => selected.user_id === row.user_id)}
                                                    onChange={() => {
                                                        const isSelected = selectedUser.some(selected => selected.user_id === row.user_id);
                                                        if (isSelected) {
                                                            setSelectedUser(selectedUser.filter(selected => selected.user_id !== row.user_id));
                                                            setSelectedUserIds(selectedUserIds.filter(id => id !== row.user_id));
                                                        } else {
                                                            setSelectedUser([...selectedUser, row]);
                                                            setSelectedUserIds([...selectedUserIds, row.user_id]);
                                                        }
                                                        setSendtoall(0);
                                                    }}
                                                    inputProps={{ 'aria-label': 'select user' }}
                                                />
                                            </TableCell>

                                            <TableCell align="center">
                                                <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                                    <Grid2>
                                                        <Avatar sx={{ borderColor: "#0065FF", border: 1 }}
                                                            alt={row.user_name} src={row.user_image}></Avatar>
                                                    </Grid2>
                                                    <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                        <Grid2><Typography>{row.user_name}</Typography></Grid2>
                                                        <Grid2>
                                                            <Typography sx={{ color: "#83888E", fontSize: "12px" }}>
                                                                {row.phone_number}
                                                            </Typography>
                                                        </Grid2>
                                                    </Grid2>
                                                </Grid2>
                                            </TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '80px' }}>{row.user_id}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.user_email}</Typography></TableCell>
                                            {show_trip_id_filter_in_bulk_push == 1 && <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '80px' }}>{row.trip_id}</Typography></TableCell>}
                                            {show_trip_id_filter_in_bulk_push == 1 && <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                                {row.trip_date
                                                    ? new Date(row.trip_date).toLocaleDateString('en-US', {
                                                        year: 'numeric', month: 'short', day: 'numeric',
                                                    })
                                                    : '-'}</Typography>
                                            </TableCell>}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            )}

                            {driverCustomer == 1 && (
                                <TableBody>
                                    {loadingUsers ? (
                                        <TableRow>
                                            <TableCell colSpan={driverColSpan} align="center" sx={{ py: 3 }}>
                                                <CircularProgress size={24} />
                                            </TableCell>
                                        </TableRow>
                                    ) : rows.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={driverColSpan} align="center" sx={{ py: 3 }}>
                                                <Typography sx={{ color: '#83888E' }}>No data received</Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : rows.map((row) => (
                                        <TableRow key={row.driver_id}>
                                            <TableCell align="center" sx={{ minWidth: '100px' }}>
                                                <Checkbox
                                                    checked={isSendToAll || selectedUser.some(selected => selected.driver_id === row.driver_id)}
                                                    onChange={() => {
                                                        const isSelected = selectedUser.some(selected => selected.driver_id === row.driver_id);
                                                        if (isSelected) {
                                                            setSelectedUser(selectedUser.filter(selected => selected.driver_id !== row.driver_id));
                                                            setSelectedUserIds(selectedUserIds.filter(id => id !== row.driver_id));
                                                        } else {
                                                            setSelectedUser([...selectedUser, row]);
                                                            setSelectedUserIds([...selectedUserIds, row.driver_id]);
                                                        }
                                                    }}
                                                    inputProps={{ 'aria-label': 'select user' }}
                                                />
                                            </TableCell>

                                            <TableCell align="center">
                                                <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                                    <Grid2>
                                                        <Avatar sx={{ borderColor: "#0065FF", border: 1 }}
                                                            alt={row.driver_name} src={row.driver_image}></Avatar>
                                                    </Grid2>
                                                    <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                        <Grid2><Typography>{row.driver_name}</Typography></Grid2>
                                                        <Grid2>
                                                            <Typography sx={{ color: "#83888E", fontSize: "12px" }}>
                                                                {row.phone_number}
                                                            </Typography>
                                                        </Grid2>
                                                    </Grid2>
                                                </Grid2>
                                            </TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.driver_id}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.email}</Typography></TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            )}
                        </Table>

                        {driverCustomer == 0 && <div className="custom-pagination">
                            <div className="pagination-info">
                                {paginationInfo.total === 0
                                    ? 'Showing 0 to 0 of 0 entries'
                                    : `Showing ${page * rowsPerPage + 1} to ${Math.min(
                                        (page + 1) * rowsPerPage,
                                        paginationInfo.total
                                    )} of ${paginationInfo.total} entries`}
                            </div>
                            <div className="pagination-controls">
                                <button
                                    onClick={() => handleChangePage(null, page - 1)}
                                    disabled={page === 0}
                                    className="pagination-arrow"
                                >
                                    <img src={prevIcon} alt="Previous" />
                                </button>
                                <div className="pagination-numbers">
                                    {Array.from({ length: totalPages }, (_, index) => index)
                                        .filter(
                                            (index) =>
                                                index === 0 ||
                                                index === totalPages - 1 ||
                                                Math.abs(index - page) <= 1
                                        )
                                        .map((index, arrayIndex, visiblePages) => {
                                            const previousPage = visiblePages[arrayIndex - 1];
                                            return (
                                                <React.Fragment key={index}>
                                                    {previousPage !== undefined &&
                                                        index - previousPage > 1 && (
                                                            <span className="pagination-dots">...</span>
                                                        )}
                                                    <button
                                                        onClick={() => handleChangePage(null, index)}
                                                        className={`pagination-number ${page === index ? 'active' : ''}`}
                                                    >
                                                        {index + 1}
                                                    </button>
                                                </React.Fragment>
                                            );
                                        })}
                                </div>
                                <button
                                    onClick={() => handleChangePage(null, page + 1)}
                                    disabled={page >= totalPages - 1}
                                    className="pagination-arrow"
                                >
                                    <img src={nextIcon} alt="Next" />
                                </button>
                            </div>
                        </div>}
                    </TableContainer>
                </Grid2>
            </Grid2>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
        </div>
    );
};

export default Pushes;